import { PaymentStateModel } from './models';

export const getOrderStatus = (state: PaymentStateModel) => {
  return state.orderStatus;
};
